export default "__VITE_ASSET__ZTTMQdgQ__"